export default "__VITE_PUBLIC_ASSET__b551b36e__"